// src/App.tsx
import { useEffect } from 'react'
import { useNavStore } from './store/navStore'

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomeHeader from "@/components/header/Header";
import MobileHeader from "@/components/header/MobileHeader";
import Footer from "@/components/common/Footer";

import Home from "@/pages/home/Home";
import Login from "@/pages/auth/Login";
import FindId from "@/pages/auth/FindId";
import FindPw from "@/pages/auth/FindPw";
import Register from "@/pages/auth/Register";

import CounselApply from "@/pages/counsel/CounselApply";
import CounselCheck from './pages/counsel/CounselCheck';
import CounselApplicationDetail from './pages/counsel/CounselApplicationDetail';

import EventRegister from "./pages/event/EventRegister";
import EventList from './pages/event/EventList'
import EventDetail from './pages/event/EventDetail'
import EventEdit from "./pages/event/EventEdit";

import ProgramList from './pages/program/ProgramList'
import ProgramDetail from './pages/program/ProgramDetail'
import ProgramApply from './pages/program/ProgramApply'
import ProgramCheck from './pages/program/ProgramCheck'
import ProgramApplicationDetail from './pages/program/ProgramApplicationDetail'

import SpaceList from "@/pages/space/SpaceList";
import SpaceDetail from "@/pages/space/SpaceDetail";
import SpaceApply from "@/pages/space/SpaceApply";
import SpaceReservationCheck from "@/pages/space/SpaceReservationCheck";

import NoticeList from "./pages/notice/NoticeList";
import NoticeDetail from "./pages/notice/NoticeDetail";
import NoticeEdit from "./pages/notice/NoticeEdit";
import NoticeRegister from "./pages/notice/NoticeRegister";

import MyPage from './pages/mypage/MyPage';
import MyPageAttendance from './pages/mypage/MyPageAttendance';
import MyPagePoint from './pages/mypage/MyPagePoint';
import MyPageEdit from './pages/mypage/MyPageEdit';

import Booksearch from './pages/book/BookSearch';
import BookLoan from './pages/book/BookLoan';
import BookRequest from './pages/book/BookRequest';

import ContentPage from './pages/page/ContentPage'
import LocationPage from './pages/page/LocationPage'

import BoardList from './pages/board/BoardList'
import BoardRegister from './pages/board/BoardRegister'


import AdminLayout from './pages/admin/AdminLayout'
import AdminMyPage from './pages/admin/mypage/AdminMyPage'
import AdminMyPageEdit from './pages/admin/mypage/AdminMyPageEdit'
import AdminDashboard from './pages/admin/dashboard/AdminDashboard'

import AdminMenu from "./pages/admin/menu/AdminMenu";
import AdminPageList from './pages/admin/page/PageList'
import AdminPageEdit from './pages/admin/page/PageEdit'

import AdminBoardManage from './pages/admin/board/AdminBoardManage'
import AdminBoardPostManage from './pages/admin/board/AdminBoardPostManage'
import AdminBoardPostEdit from './pages/admin/board/AdminBoardPostEdit'



import AdminMemberList from './pages/admin/member/AdminMemberList';
import AdminMemberDetail from './pages/admin/member/AdminMemberDetail';

import AdminAttendanceList from './pages/admin/attendance/AdminAttendanceList';
import AdminAttendanceDetail from './pages/admin/attendance/AdminAttendanceDetail';

import AdminSpaceManagement from './components/admin/AdminSpaceManagement'
import AdminSpaceReservationDetail from '@/pages/admin/space/AdminSpaceReservationDetail'
import AdminSpaceForm from '@/pages/admin/space/AdminSpaceForm'


import AdminProgramList from '@/pages/admin/program/AdminProgramList'
import AdminProgramForm from '@/pages/admin/program/AdminProgramForm'
import AdminProgramApplicationList from '@/pages/admin/program/AdminProgramApplicationList'
import AdminProgramApplicationDetail from '@/pages/admin/program/AdminProgramApplicationDetail'

import AdminCounselList from '@/pages/admin/counsel/AdminCounselList'
import AdminCounselDetail from '@/pages/admin/counsel/AdminCounselDetail'

import AdminPointManagement from './pages/admin/point/AdminPointManagement';
import AdminPointAdjust from './pages/admin/point/AdminPointAdjust';

import AdminLockerPage from '@/pages/admin/locker/AdminLockerPage'

import AdminKioskMenuList from './pages/admin/kiosk/menu/MenuList'
import PostList from './pages/admin/kiosk/post/PostList'
import PostRegister from './pages/admin/kiosk/post/PostRegister'
import PostEdit from './pages/admin/kiosk/post/PostEdit'
import PostDetail from './pages/admin/kiosk/post/PostDetail'
import AdminAccessibilitySettings from './pages/admin/kiosk/accessibility/AdminAccessibilitySettings'
import AdminDisplaySettings from './pages/admin/kiosk/display/AdminDisplaySettings'

import AdminNoticeList from './pages/admin/notice/AdminNoticeList'
import AdminNoticeEdit from './pages/admin/notice/AdminNoticeEdit'
import AdminEventList from './pages/admin/event/AdminEventList'
import AdminEventEdit from './pages/admin/event/AdminEventEdit'

import AdminWishBookList from './pages/admin/wishbook/AdminWishBookList'

import AdminLibraryManagement from './pages/admin/library/AdminLibraryManagement'
import AdminBookDetail from './pages/admin/library/AdminBookDetail'
import AdminCompanyManagement from './components/admin/AdminCompanyManagement'




function App(): React.JSX.Element {
  const fetchNavItems = useNavStore(s => s.fetchNavItems)
  
  useEffect(() => {
    fetchNavItems()
  }, [])



  return (
    <BrowserRouter>
      <Routes>
        {/* 관리자 - 헤더/푸터 없음 */}
        <Route path="/admin/*" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="mypage" element={<AdminMyPage />} />
          <Route path="mypage/edit" element={<AdminMyPageEdit />} />
          <Route path="menu" element={<AdminMenu />} />
          <Route path="page" element={<AdminPageList />} />
          <Route path="page/new" element={<AdminPageEdit />} />
          <Route path="page/:id" element={<AdminPageEdit />} />

          <Route path="board" element={<AdminBoardManage />} />
          <Route path="board/:slug/post" element={<AdminBoardPostManage />} />
          <Route path="board/:slug/post/new" element={<AdminBoardPostEdit />} />
          <Route path="board/:slug/post/:id" element={<AdminBoardPostEdit />} />

          <Route path="member" element={<AdminMemberList />} />
          <Route path="member/:member_id" element={<AdminMemberDetail />} />

          <Route path="attendance" element={<AdminAttendanceList />} />
          <Route path="attendance/:login_id" element={<AdminAttendanceDetail />} />

          <Route path="space" element={<AdminSpaceManagement />} />
          <Route path="space/reservations/:reservation_id" element={<AdminSpaceReservationDetail />} />
          <Route path="space/create" element={<AdminSpaceForm />} />
          <Route path="space/:space_id" element={<AdminSpaceForm />} />

          <Route path="program" element={<AdminProgramList />} />
          <Route path="program/create" element={<AdminProgramForm />} />
          <Route path="program/:program_id" element={<AdminProgramForm />} />
          <Route path="program/:program_id/applications" element={<AdminProgramApplicationList />} />
          <Route path="program/:program_id/applications/:application_id" element={<AdminProgramApplicationDetail />} />

          <Route path="counsel" element={<AdminCounselList />} />
          <Route path="counsel/:application_id" element={<AdminCounselDetail />} />

          <Route path="point" element={<AdminPointManagement />} />
          <Route path="point/adjust" element={<AdminPointAdjust />} />

          <Route path="locker" element={<AdminLockerPage />} />

          <Route path="kiosk/menu" element={<AdminKioskMenuList />} />
          <Route path="kiosk/content" element={<PostList />} />
          <Route path="kiosk/content/register" element={<PostRegister />} />
          <Route path="kiosk/content/edit/:content_code" element={<PostEdit />} />
          <Route path="kiosk/content/detail/:content_code" element={<PostDetail />} />
          <Route path="kiosk/accessibility" element={<AdminAccessibilitySettings />} />
          <Route path="kiosk/display" element={<AdminDisplaySettings />} />

          <Route path="notice" element={<AdminNoticeList />} />
          <Route path="notice/new" element={<AdminNoticeEdit />} />
          <Route path="notice/:id" element={<AdminNoticeEdit />} />


          <Route path="event" element={<AdminEventList />} />
          <Route path="event/new" element={<AdminEventEdit />} />
          <Route path="event/:id" element={<AdminEventEdit />} />

          <Route path="wishbook" element={<AdminWishBookList />} />
          
          <Route path="library" element={<AdminLibraryManagement />} />
          <Route path="library/book/:book_code" element={<AdminBookDetail />} />

          <Route path="company" element={<AdminCompanyManagement />} />
          

        </Route>

        {/* 일반 페이지 - 헤더/푸터 있음 */}
        <Route path="/*" element={
          <>
            <div className="hidden md:block"><HomeHeader /></div>
            <div className="block md:hidden"><MobileHeader /></div>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/find_id" element={<FindId />} />
              <Route path="/auth/find_pw" element={<FindPw />} />
              <Route path="/auth/register" element={<Register />} />


              <Route path="/counsel/apply" element={<CounselApply />} />
              <Route path="/counsel/check" element={<CounselCheck />} />
              <Route path="/counsel/check/:application_id" element={<CounselApplicationDetail />} />

              <Route path="/event" element={<EventList />} />
              <Route path="/event/register" element={<EventRegister />} />
              <Route path="/event/:event_id" element={<EventDetail />} />
              <Route path="/event/edit/:event_id" element={<EventEdit />} />

              <Route path="/program" element={<ProgramList />} />
              <Route path="/program/check" element={<ProgramCheck />} />
              <Route path="/program/check/:application_id" element={<ProgramApplicationDetail />} />
              <Route path="/program/:program_id" element={<ProgramDetail />} />
              <Route path="/program/:program_id/apply" element={<ProgramApply />} />

              <Route path="/space" element={<SpaceList />} />
              <Route path="/space/check" element={<SpaceReservationCheck />} />
              <Route path="/space/:space_id" element={<SpaceDetail />} />
              <Route path="/space/:space_id/apply" element={<SpaceApply />} />

              <Route path="/notice" element={<NoticeList />} />
              <Route path="/notice/register" element={<NoticeRegister />} />
              <Route path="/notice/edit/:notice_id" element={<NoticeEdit />} />
              <Route path="/notice/:notice_id" element={<NoticeDetail />} />

              <Route path="/mypage" element={<MyPage />} />
              <Route path="/mypage/edit" element={<MyPageEdit />} />
              <Route path="/mypage/point" element={<MyPagePoint />} />
              <Route path="/mypage/attendance" element={<MyPageAttendance />} />

              <Route path="/book" element={<Booksearch />} />
              <Route path="/book/loan" element={<BookLoan />} />
              <Route path="/book/request" element={<BookRequest />} />

              <Route path="/board/:slug" element={<BoardList />} />
              <Route path="/board/:slug/register" element={<BoardRegister />} />

              <Route path="/page/:slug" element={<ContentPage />} />
              <Route path="/page/location" element={<LocationPage />} />
            </Routes>
            <Footer />
          </>
        } />
      </Routes>
    </BrowserRouter>
  )
}


export default App;